<script setup lang="ts">
/**
 * UI-kit component
 * Category: 'Buttons'
 * Name: 'Icon'
 * FIGMA: 'https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=3449-4279&t=6CTl5z4NeoYM2d97-4'
 */
import type { BtnIconProps } from '../types/interfaces'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { TooltipPrimary } from '@shared/ui/tooltips'
import { IconContainer } from '@shared/ui/other'

import { useBtnIcon } from '../composables/use-btn-icon.hook'

defineOptions({
  name: 'BtnIcon',
})

const props = withDefaults(defineProps<BtnIconProps>(), {
  color: 'black',
  view: 'default',
  size: 'medium',
  tooltipText: '',
  title: '',
  disabled: false,
})

const emit = defineEmits<{
  click: [PointerEvent]
  'click:close': [Event]
}>()

const {
  ariaLabel,
  handleClick,
  handleClickClose,
} = useBtnIcon({
  props,
  onClick: (event: PointerEvent) => emit('click', event),
  onClickClose: (event: Event) => emit('click:close', event),
})
</script>

<template>
  <div :class="['ui-btn-icon-container', { tooltip: !!tooltipText }, size]">
    <button
      type="button"
      :title="title"
      :aria-label="ariaLabel"
      :class="['ui-btn-icon', view, color]"
      :disabled="disabled"
      @click="handleClick"
      @click.stop="handleClickClose"
    >
      <IconContainer>
        <FontAwesomeIcon
          :icon="icon"
        />
      </IconContainer>
    </button>
    <TooltipPrimary
      v-if="tooltipText"
      :text="tooltipText"
    />
  </div>
</template>

<style lang="scss" scoped src="../styles/_btn-icon.scss" />
